import { $$$ } from '@suntex.core/text'
import { asPath } from '@suntex.core/text/extensions'
import { MeasurementType } from '@suntex.fim/enums'

/**
 * Turns a module description (e.g. "Measurement World: Making Change -
 * Rupees") into a display name. Pre-K games live under "K2 World" in the
 * data but should show "Pre-K" instead of "K2". Pass the game's `slug` so
 * games like "K2 World: Link 'N Lock - Mosaic" (whose text has no "PreK"
 * to detect) still get the same treatment based on their slug.
 */
// link-n-lock-mosaic is the one Pre-K slug that doesn't start with "pk-"
// and whose text has no "PreK" in it, so it needs to be called out explicitly.
const NON_PK_PREFIXED_PRE_K_SLUGS = new Set(['link-n-lock-mosaic'])

export function parseModuleReference(reference: string) {
  const [slug, variant = ''] = reference.trim().split('|')
  const variantNumber = variant ? Number(variant) : undefined
  const useUSLabel =
    variantNumber === MeasurementType.English &&
    ['equal-length', 'equal-weight'].includes(slug)
  let variantName: string | undefined
  if (variantNumber !== undefined) {
    variantName = useUSLabel ? 'US' : MeasurementType[variantNumber]
  }
  return {
    slug: slug.trim(),
    variant: variantNumber,
    variantName
  }
}

export function getModuleUrl(
  url: string,
  params: {
    suggestionKey?: string
    moduleVariant?: number
  }
): string {
  return $$$(url, asPath()).withParams(params).$$
}

export function getModuleDisplayName(text: string, slug?: string): string {
  const isPreKGame =
    /^K2 World:\s*PreK\b/i.test(text) ||
    (slug !== undefined &&
      (slug.startsWith('pk-') || NON_PK_PREFIXED_PRE_K_SLUGS.has(slug)))

  let displayName = text
  if (isPreKGame) {
    displayName = displayName
      .replace(/^K2 World:\s*PreK\s*/i, 'Pre-K ')
      .replace(/^K2 World:\s*/i, 'Pre-K ')
  } else {
    displayName = displayName.replace(/^K2 World:\s*/i, 'K2 ')
  }

  displayName = displayName.replace(/^Pre Kindergarten:\s*/i, 'Pre-K ')

  if (displayName.includes(':')) {
    displayName = displayName.split(':').slice(1).join(':').trim()
  }

  return displayName.trim()
}
